import React, { useState, useEffect } from 'react'
import { ethers } from 'ethers'

const WalletConnect = ({ defaultAccountChange }) => {
    const [defaultAccount, setDefaultAccount] = useState(null)
    const [correctNetwork, setCorrectNetwork] = useState(null);
    const [connectButtonText, setConnectButtonText] = useState('Connect Wallet')

    useEffect(() => {
        changingAccount();
        defaultAccountChange(defaultAccount);
    }, [defaultAccount])

    async function changingAccount() {
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', () => {
                connectWalletHandler()
            })
        }
    }

    const connectWalletHandler = async () => {
        if (window.ethereum) {
            window.ethereum.request({ method: 'eth_requestAccounts' })
                .then(async (result) => {
                    await accountChangeHandler(result[0]);
                    setConnectButtonText(`${result[0].slice(0, 4)}...${result[0].slice(-4)}`);
                })
        } else {
            alert('Need to install MetaMask!')
        }
    }

    const accountChangeHandler = async (newAccount) => {
        checkCorrectNetwork();
        setDefaultAccount(newAccount);
    }

    const checkCorrectNetwork = async () => {
        const { ethereum } = window
        let chainId = await ethereum.request({ method: 'eth_chainId' })
        console.log('Connected to chain:' + chainId)

        const netWorkID = '0x2b6f'

        if (chainId !== netWorkID) {
            setCorrectNetwork(false)
            console.log("Please Connect to the Correct Network")
        } else {
            setCorrectNetwork(true)
        }
    }

    return (
        <div className ="btnConnect">
            <button onClick={connectWalletHandler} className="buttonConnect">{connectButtonText}</button>
        </div>
    )
}

export default WalletConnect
